<span class="icc-badge-chip-content">
    <ng-content></ng-content>
</span>